import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { useTranslation } from "@i18n";
import Container from "@/components/sharedComponents/container/Container";
import ResponsivePostGrid from "@/components/shared/Grid/ResponsivePostGrid";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import useIsMobile from "@hooks/useIsMobile";
var ChineseUsedCarsSection = function ChineseUsedCarsSection() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _ref = useFullPageData() || {},
    chineseUsedCars = _ref.chineseUsedCars;
  var displayedPosts = chineseUsedCars || [];
  var isMobile = useIsMobile();
  var ctaLink = "/filters?condition_id=0&make_country=1";
  if (!displayedPosts.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
    id: "posts-chinese-used-cars",
    className: "py-4 md:py-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex mb-6"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "posts-chinese-used-cars-title",
    className: "text-primary text-lg lg:text-2xl font-bold"
  }, tShort("chinese_used_cars/title"))), /*#__PURE__*/React.createElement(ResponsivePostGrid, {
    posts: displayedPosts,
    ctaLink: ctaLink,
    sectionType: "listing"
  }), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mt-6 mx-auto w-[250px]"
  }, /*#__PURE__*/React.createElement(Link, {
    id: "posts-chinese-used-cars-cta",
    to: ctaLink,
    className: "rounded w-full bg-[#FE561C] px-6 py-3 text-center text-white text-sm font-bold leading-4 outline-none border-none cursor-pointer hover:text-white hover:bg-[#e54a19] transition-colors"
  }, t("show", {
    ns: "web_common"
  })))));
};
export default ChineseUsedCarsSection;